import React from "react";
import Marquee from "react-fast-marquee";
import { NavLink } from "react-router-dom";
import { useGetAllLatestNewsPublicQuery } from "../../Redux/getApi";

const NewsMarque = () => {
  const { data: latestNewsData } = useGetAllLatestNewsPublicQuery();
  const originalData = latestNewsData?.latestNews || [];

  const marqueeData =
    originalData.length >= 10
      ? originalData
      : originalData.length
        ? Array(Math.ceil(10 / originalData.length))
            .fill(originalData)
            .flat()
            .slice(0, 10)
        : [];

  return (
    <div className="relative lg:h-16 md:h-14 h-12 w-full overflow-hidden  xl:my-8 lg:my-6 md:my-4 my-2">
      {/* Latest News Label */}
      <div className="absolute left-0 top-0 bottom-0 z-10 bg-[#00643B]">
        <span className="flex justify-center items-center text-white lg:text-[24px] md:text-[20px] text-[16px] font-bold md:px-6 px-4 w-max h-full">
          Latest News
        </span>
      </div>

      {/* Left Fade Effect */}
      <div className="absolute md:left-[160px] left-[120px] top-0 bottom-0 lg:w-40 md:w-24 w-16 bg-gradient-to-r from-[#00643B] to-transparent z-10 pointer-events-none" />

      {/* Marquee Content */}
      {marqueeData?.length > 0 ? (
        <Marquee
          direction="left"
          gradient={false}
          pauseOnHover={true}
          className="text-white bg-[#00643B] font-medium lg:text-[20px] md:text-[16px] text-[13px] h-full pl-[200px] flex items-center lg:gap-12 md:gap-8 gap-4"
        >
          {marqueeData?.map((marquee, i) => (
            <NavLink
              to={marquee?.doc?.docUrl}
              key={i}
              target="_blank"
              className={"pr-6"}
            >
              {marquee?.title}
            </NavLink>
          ))}
        </Marquee>
      ) : (
        <div className="w-full flex items-center justify-center text-white font-medium bg-[#00643B] h-full lg:text-[20px] md:text-[16px] text-[13px]">
          No news available
        </div>
      )}
    </div>
  );
};

export default NewsMarque;
